import axios from "axios";
const request=axios.create({
    baseURL:'https://fjqccnc.com/zyapi/h5',
    // baseURL:'http://192.168.10.26:8080/zyapi/h5',
    timeout:150000  
})
export default request